/* eslint-disable max-len */
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from 'moment'

import { initRevType, type, criteria } from '../../../constants'
import { SearchSelect, NumberInput } from '../../../../../../input'
import { FONTS } from '../../../../../../../constants'
import { formatNumber } from '../../../../../../../function/math.js'
import { projectInformationSelector } from '../../../../../../../selectors'
import { REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE } from '../../../../../../../lib/utils/envConstants'

export const InputSecondRow = React.memo((props) => {
  const {
    id,
    data,
    isEdit,
    lobData = [],
    invalidList,
    allocation_id,
    handleChangeSelect,
    handleChangeInput,
  } = props
  const ppsLatestSubmittedDate = useSelector(projectInformationSelector.getPPSLatestSubmittedDate)

  const lobAllocation = get(data, 'lobs', [])[id]
  const { lob_percent, lob_revenue, lob_id, start_date } = lobAllocation
  const showInitRev = initRevType[data.lobs[id].criteria]

  const lobOptions = lobData.map(v => ({ label: v.name, value: v._id }))
  const lob = lobData.map(v => ({ label: v.name, value: v._id })).find(l => l.value === lob_id) || null
  const isDisable = !REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE && ppsLatestSubmittedDate !== '' && moment(ppsLatestSubmittedDate).isSameOrAfter(start_date, 'month')

  return (
    <Root>
      <FormWrapper>
        <Label>LOB</Label>
        { data.type === type.SERVICE ?
          <Text>{ lob ? lob.label : '-' }</Text>
          :
          <SearchSelect
            menuPosition='absolute'
            options={ lobOptions }
            value={ lob }
            invalid={ isEdit && invalidList[`${allocation_id}_${id}_lob_id`] }
            onChange={ e => handleChangeSelect(e, allocation_id, id, 'lob_id') }
            isDisabled={ !isEdit || data.type === type.SERVICE || isDisable }
          />
        }
      </FormWrapper>
      <FormWrapper>
        <Label>LOB Rev.</Label>
        { lobAllocation.criteria === criteria.DELIVERY || lobAllocation.criteria === criteria.INSTALLATION ?
          <Text>{ lob_revenue }</Text>
          :
          <NumberInput
            name='lob_revenue'
            allowEmptyFormatting={ true }
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            allowNegative={ true }
            disabled={ !isEdit || !showInitRev }
            onChange={ e => formatNumber(e.target.value) }
            onBlur={ e => handleChangeInput(e, allocation_id, id, 'lob_revenue') }
            value={ lob_revenue }
          />
        }
      </FormWrapper>
      <FormWrapper>
        <Label>LOB %</Label>
        <Text>{ `${lob_percent} %` }</Text>
      </FormWrapper>
    </Root>
  )
})

const Root = styled.div`
  height: 50px;
  display: flex;
  margin-bottom: 10px;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
      padding-right: 6px;
  }

  :nth-last-child(1) {
      padding-left: 6px;
  }
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #808080;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`

const Text = styled.div`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  height: 30px;
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/project-detail/input-second-row.js